import React from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { storeCategories } from "../../home/redux/actions";
import { maintainStoretype } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};
function CategorycardPage (props) {
  const {width} = getWindowDimensions()
  const { type } = props;
   const { t } = useTranslation();
   let getUrl = window.location.pathname.split("/").pop();
   const navigate = useNavigate();

   const selectCategory = (id, storetype) => {
      let getCategories = [];
      props?.categories?.forEach((item, index) => {
        if (item?.id === id) {
          props.categories[index].is_checked = true;
        } else {
          props.categories[index].is_checked = false;
        }
        getCategories.push(props.categories[index]);
      });
      props.storeCategories(getCategories);
      props.maintainStoretype(storetype);
      var timestamp = new Date().getTime();
      navigate("/stores/"+id, { state: { obj: timestamp } });
    };

   return (
      <div
      onClick={getUrl==="catalog"?()=>props?.selectCategorychange(props?.item):()=>selectCategory(props?.item?.id, type)}
      className="col-3 home_category bounceIn"
    >
      <Card
        className={props?.type === "goods"?"transition":"transition services-card"}
        style={{
          backgroundImage: `url('${width > 700 ? props?.item?.web_image_url : props?.item?.mobile_image_url}')`,
          height: props?.card_style?.height,
          minHeight:props?.card_style?.minHeight,
          marginBottom:props?.card_style?.marginBottom,
        }}
      >
        <Card.Body>
          <h5 className="secound-title secound-color">
            {props?.type === "goods"?t("pages.home.goods"):t("pages.home.service")}
          </h5>
          <h5 className="primary-title text-white">
            {props?.item?.title}
          </h5>
        </Card.Body>
      </Card>
       <h5 className="categ-mob-title m-0" style={props?.item?.type === "goods"?{}:{color:'#545668'}}>{props?.item?.title}</h5>
    </div>
   )

}


const mapStateToProps = (state) => ({
  categories: state?.home?.categories,
})

export default connect(mapStateToProps, {storeCategories,maintainStoretype})(CategorycardPage)
